// extracted by mini-css-extract-plugin
export default {"minInvestItem":"RaiseStartupForm_minInvestItem__kALls","maxInvestItem":"RaiseStartupForm_maxInvestItem__00m1G"};